import React, {useEffect} from 'react';
import {useLocaleKeys} from '../../../locale-keys/LocaleKeys';
import {PaymentRequestView} from './PaymentRequestView';
import {useControllerProps} from '../Widget/ControllerContext';

export enum ExpiredViewDataHook {
  root = 'ExpiredViewDataHook.root',
  view = 'ExpiredViewDataHook.view',
}

export const ExpiredView = () => {
  const {
    paymentRequestStore: {sendPaymentRequestExpiredPageLoadBIEvent},
  } = useControllerProps();
  const localeKeys = useLocaleKeys();

  useEffect(
    () => {
      sendPaymentRequestExpiredPageLoadBIEvent();
    },
    /* eslint-disable react-hooks/exhaustive-deps */ []
  );

  return (
    <div data-hook={ExpiredViewDataHook.root}>
      <PaymentRequestView
        dataHook={ExpiredViewDataHook.view}
        title={localeKeys.checkout.payLinks.linkExpired.title()}
        subtitle={localeKeys.checkout.payLinks.linkExpired.subtitle()}
      />
    </div>
  );
};
